import { Outlet } from 'react-router-dom';
import CookieConfigProvider from '../providers/CookieConfigProvider';
import { Analytics } from '../providers/Analytics';
import { TrackPageView } from '../providers/TrackPageView';
import StoreProvider from '../redux/StoreProvider';
import { BrandingProviderWithSuspense } from '../contexts/BrandingProviderWithSuspense';
import GradientLayout from '@/components/GradientLayout';

export default function RootLayout() {
  return (
    <>
      <Analytics />
      <TrackPageView />
      <CookieConfigProvider />
      <StoreProvider>
        <BrandingProviderWithSuspense>
          <GradientLayout>
            <Outlet />
          </GradientLayout>
        </BrandingProviderWithSuspense>
      </StoreProvider>
    </>
  );
}
